import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable()
export class AuthenticationService {
  roll_id: any;
  userType: any = [
    { type: "Institute User", role_type: "INSTITUTE", role_id: "2" },
    { type: "ROE User", role_type: "ROE", role_id: "3" },
    { type: "Reporting User", role_type: "REPORTING", role_id: "4" },
    { type: "Venue User", role_type: "VENUE", role_id: "5" },
    { type: "Food User", role_type: "FOOD", role_id: "6" },
    { type: "PR User", role_type: "PR", role_id: "7" },
    { type: "Finance User", role_type: "FINANCE", role_id: "9" },
  ];
  roleidArray: any = [];
  selectedrole: any = "";
  selectedroletype: any;
  constructor(private http: HttpClient) {}
  register(
    name: string,
    email: string,
    password: string,
    cpassword: any,
    phoneNumber: any,
    phone: any,
    company: any,
    address1: any,
    address2: any,
    country: any,
    state: any,
    city: any,
    refrral: any,
    plansId = ""
  ) {
    return this.http
      .post<any>(`${environment.apiUrl}${environment.apiPrefix}/user/signup`, {
        name: name,
        email: email,
        password: password,
        cpassword: cpassword,
        company: company,
        phoneNumber: phoneNumber,
        phone: phone,
        address1: address1,
        address2: address2,
        country: country,
        state: state,
        city: city,
        refrral: refrral,
        plansId: plansId,
      })
      .pipe(
        map((user) => {
          if (user.status.code == 0) {
            localStorage.setItem(
              `${environment.appName}` + "_user",
              user.data.access_token
            );
            localStorage.setItem(
              `${environment.appName}` + "_adminName",
              user.user.name
            );
            localStorage.setItem(
              `${environment.appName}` + "_adminId",
              user.user._id
            );
            localStorage.setItem(
              `${environment.appName}` + "_role",
              user.user.roleId
            );
            localStorage.setItem(
              `${environment.appName}` + "_status",
              user.user.status
            );
            localStorage.setItem(`${environment.appName}` + "_domain", "");
          }

          return user;
        })
      );
  }

  login(email: string, password: string) {
    return this.http
      .post<any>(`${environment.apiUrl}${environment.apiPrefix}/user/login`, {
        userID: email,
        password: password,
      })
      .pipe(
        map((user) => {
          // login successful if there's a jwt token in the response
          // return false;
          if (user.status.code == 0) {
            localStorage.setItem(
              `${environment.appName}` + "_user_obj",
              JSON.stringify(user.user)
            );
            localStorage.setItem(
              `${environment.appName}` + "_user_room",
              JSON.stringify(user.room)
            );
            localStorage.setItem(
              `${environment.appName}` + "_user_room_details",
              user.user.room_details
            );
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem(
              `${environment.appName}` + "_user",
              user.data.accessToken
            );
            localStorage.setItem(
              `${environment.appName}` + "_adminName",
              user.user.name
            );
            localStorage.setItem(
              `${environment.appName}` + "_adminId",
              user.user._id
            );
            localStorage.setItem(
              `${environment.appName}` + "_userId",
              user.user._id
            );
            localStorage.setItem(
              `${environment.appName}` + "_role",
              user.user.roleId
            );
            localStorage.setItem(
              `${environment.appName}` + "_status",
              user.user.status
            );
            localStorage.setItem(
              `${environment.appName}` + "_domain",
              user.user.shop ? user.user.shop.domain : ""
            );
          }

          return user;
        })
      );
  }

  getUser(): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${environment.apiPrefix}/subadmin/get-user`
      )
      .pipe(map((user) => user));
  }

  logout() {
    localStorage.removeItem(`${environment.appName}` + "_user");
    localStorage.removeItem(`${environment.appName}` + "_userid");
    localStorage.removeItem(`${environment.appName}` + "_role");
    localStorage.removeItem(`${environment.appName}` + "_ins_Id");
    // localStorage.removeItem(`${environment.appName}` + "userType");
    localStorage.removeItem(`${environment.appName}` + "eventId");
    localStorage.removeItem(`${environment.appName}` + "selectedroletype");
    localStorage.removeItem(`${environment.appName}` + "_fullName");
    localStorage.removeItem(`${environment.appName}` + "selectedrole");
    localStorage.removeItem(`${environment.appName}` + "usertype");
  }

  sendOtp(phoneno_or_email: any) {
    const formData: FormData = new FormData();
    formData.append("phoneno_or_email", phoneno_or_email);
    return this.http
      .post<any>(
        `${environment.apiUrl}${environment.apiPrefix}/subadmin/send-otp`,
        formData
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  verifyOtp(phoneno_or_email: any, otp: any) {
    var formData = {
      phoneno_or_email: phoneno_or_email,
      otp: otp,
    };
    return this.http
      .post<any>(
        `${environment.apiUrl}${environment.apiPrefix}/subadmin/verify-otp`,
        formData
      )
      .pipe(
        map((user) => {
          if (user.status.code == 0) {
            localStorage.setItem(
              `${environment.appName}` + "_user",
              user.data.token
            );
            localStorage.setItem(
              `${environment.appName}` + "_userid",
              user.data.user._id
            );
            localStorage.setItem(
              `${environment.appName}` + "_role",
              JSON.stringify(user.data.user.role_id)
            );
            localStorage.setItem(
              `${environment.appName}` + "_ins_Id",
              user.data.user.institution_id
            );
            localStorage.setItem(
              `${environment.appName}` + "_fullName",
              user.data.user.full_name
            );

            localStorage.setItem(
              `${environment.appName}` + "eventId",
              user.data.user.eventId
            );
            const storedRole = localStorage.getItem(
              `${environment.appName}_role`
            );
            this.roll_id = storedRole ? JSON.parse(storedRole) : null;

            user.data.user.role_id.forEach((data) => {
              this.userType.forEach((item) => {
                if (data == item.role_id) {
                  this.roleidArray.push(item);
                  console.log(this.selectedrole);
                  this.selectedrole = this.roleidArray[0].role_id;
                  this.selectedroletype = this.roleidArray[0].role_type;
                }
              });
            });
            console.log(this.roleidArray, "fsdhgkjfgasdkjhf");
            localStorage.setItem(
              `${environment.appName}` + "usertype",
              JSON.stringify(this.roleidArray)
            );
            localStorage.setItem(
              `${environment.appName}` + "selectedrole",
              this.selectedrole
            );
            localStorage.setItem(
              `${environment.appName}` + "selectedroletype",
              this.selectedroletype
            );
          }
          return user;
        })
      );
  }

  public isAuth() {
    if (localStorage.getItem(`${environment.appName}` + "_user")) {
      return true;
    } else {
      return false;
    }
  }
}
